<template><div><h1 id="fremdadressen-dubletten-suchen" tabindex="-1"><a class="header-anchor" href="#fremdadressen-dubletten-suchen"><span>Fremdadressen: Dubletten suchen</span></a></h1>
<p>Fremdadressen: Dubletten suchen — Fremdadress-Dubletten bereinigen, zusammenführen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Das Programm sucht automatisch nach Dubletten und markiert diese. In einem zweiten Schritt (siehe markierte Dubletten bereinigen/zusammenführen) können markierte Dubletten überprüft und anschliessend bereinigt werden. Aufgrund der eventuell hohen Laufzeit wird empfohlen, das Programm im Hintergrund zu starten.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Personen → Datenpflege → Dubletten, Haushalte → Fremdadressen → Dubletten suchen</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Dublettensuche beginnen bei Name</dt>
<dd>Einschränken der Dublettensuche nach Name</dd>
<dt>Ausgabe</dt>
<dd>Standard</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Protokolldatei</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Adressdaten von den Fremdadressen.</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Dubletten in den Fremdadressen werden markiert.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


